// React & Libraries
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';

// Ant Design
import { Select } from 'antd';

// FontAwesome
import { counter } from '@fortawesome/fontawesome-svg-core';

// UI Components
import H3FormInput from '@Uilib/h3FormInput';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import PRZSelect from '../../UI/PRZSelect';

// Actions
import SellerActions from '@Actions/sellerActions';
import ProductActions from '@Actions/productActions';
import AddressActions from '@Actions/addressActions';

// Constants & Helpers
import { Countries } from '@Apis/constants';
import { GetTallyConfigurations } from '../../../../modules/getTallyConfigurations';

// Styles
import './style.scss';

/**
 *
 */
class NewAddressForm extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      productName: '',
      gstin: '',
      pinCodeShipping: '',
      district: '',
      addressShipping: '',
      stateShipping: '',
      quantity: '',
      hsnCode: '',
      expenseDocuments: [{ key: uuidv4(), document_name: '', url: '' }],
      uploadState: false,
      unit: '',
      fileList: [],
      tallyAddressType: '',
    };
  }

  /**
   *
   * @param props
   * @param state
   * @return {*&{district: *, state: *}}
   */
  static getDerivedStateFromProps(props, state) {
    if (props.pincodeCity) {
      const city = props.pincodeCity;
      const cityState = props.pincodeState;
      props.setCityState(null, null);
      return {
        ...state, district: city, state: cityState,
      };
    }
    if (!state.country) {
      return {
        ...state,
        country: Countries.find((item) => item?.code === props.user?.tenant_info?.country_code)?.name,
      };
    }
    return state;
  }

  /**
   *
   */
  componentDidMount() {
    const { getTallyConfigurations, user } = this.props;

    if (this.isTallyConnected()) {
      getTallyConfigurations({
        query: {
          org_id: user?.org_id,
          column_type: 'ADDRESS',
        },
      }, () => {});
    }
  }

  /**
   *
   */
  addAddress = () => {
    this.setState({ formSubmitted: true });
    const {
      address, district, state, pinCode, selectedTenant, country, tallyAddressType,
    } = this.state;
    const {
      seller, createAddress, addressType, selectedTenantId,
    } = this.props;
    const {
      callback, user, entityType, entityId,
    } = this.props;

    if (address && district && state && pinCode) {
      const payload = {
        address1: address,
        address2: '',
        address3: '',
        city: district,
        state,
        country,
        postal_code: pinCode,
        entity_type: entityType,
        entity_id: entityId,
        tally_address_type: tallyAddressType,
      };
      createAddress(payload, (addressResponse) => {
        callback(addressResponse);
        this.setState({
          address: '',
          district: '',
          state: '',
          pinCode: '',
          formSubmitted: false,
          tallyAddressType: '',
        });
      });
    }
  }

  isTallyConnected = () => {
    const { user, tenantId } = this.props;

    const orgId = user?.org_id;

    const tallyTenant = user?.user_tenants?.find((item) => (item?.org_id === orgId && item?.tenant_id === tenantId));

    return !!tallyTenant?.it_id;
  }

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const {
      createAddressLoading, getCityState, tallyConfigurationsLoading, tallyConfigurations,
    } = this.props;
    const {
      formSubmitted,
      address, district, state, pinCode, country, tallyAddressType,
    } = this.state;
    return (
      <div className="ant-row">
        <div className="ant-col-md-24 ant-col-xs-24">
          <div className="orgInputContainer">
            <H3FormInput
              isTextarea
              name="street address"
              type="text"
              containerClassName="orgInputContainer"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput address-text-area"
              placeholder=""
              onChange={(event) => this.setState({ address: event.target.value })}
              value={address}
              label="Street"
              showError={formSubmitted && !address}
              required
              disabled={createAddressLoading}
            />
          </div>
        </div>
        <div className="ant-col-md-24 ant-col-xs-24">
          <H3FormInput
            name="a valid pincode"
            type="number"
            containerClassName="orgInputContainer"
            labelClassName="orgFormLabel"
            inputClassName="orgFormInput"
            placeholder=""
            onChange={(event) => (event.target.value.length <= 6 ? this.setState({ pinCode: event.target.value }) : '')}
            onBlur={(event) => (event.target.value.length <= 6 ? getCityState(event.target.value) : '')}
            value={pinCode}
            label="Pin Code"
            required
            showError={formSubmitted && !pinCode}
            disabled={createAddressLoading}
          />
        </div>
        <div className="ant-col-md-24 ant-col-xs-24">
          <H3FormInput
            name="district"
            type="text"
            containerClassName="orgInputContainer"
            labelClassName="orgFormLabel"
            inputClassName="orgFormInput"
            placeholder=""
            onChange={(event) => this.setState({ district: event.target.value })}
            value={district}
            label="District"
            showError={formSubmitted && !district}
            required
            disabled={createAddressLoading}
          />
        </div>
        <div className="ant-col-md-24 ant-col-xs-24">
          <H3FormInput
            name="state"
            type="text"
            containerClassName="orgInputContainer"
            labelClassName="orgFormLabel"
            inputClassName="orgFormInput"
            placeholder=""
            onChange={(event) => this.setState({ state: event.target.value })}
            value={state}
            label="State"
            showError={formSubmitted && !state}
            required
            disabled={createAddressLoading}
          />
        </div>
        <div className="ant-col-md-24 ant-col-xs-24">
          <label className="orgFormLabel"> Country</label>
          <PRZSelect
            value={country}
            disabled={createAddressLoading}
            showSearch
            onChange={(value) => {
              this.setState({
                country: value,
              });
            }}
            showError={formSubmitted && !country}
            errorName="*Please enter country"
            errorClassName="input-error"
            style={{
              marginBottom: '12px',
            }}
          >
            {Countries?.map((ctr) => <Option key={ctr.code} value={ctr.name}>{ctr.name?.toProperCase()}</Option>)}

          </PRZSelect>
        </div>
        {this.isTallyConnected() && (
          <div className="ant-col-md-24 ant-col-xs-24">
            <label className="orgFormLabel"> Tally Address Type</label>
            <PRZSelect
              value={tallyAddressType}
              disabled={createAddressLoading || tallyConfigurationsLoading}
              onChange={(value) => {
                this.setState({
                  tallyAddressType: value,
                });
              }}
            >
              {tallyConfigurations?.tally_address_types?.map((item) => (
                <Option key={item?.address_type}>
                  {item?.address_type}
                </Option>
              ))}
            </PRZSelect>
          </div>
        )}
        <div className="ant-col-md-6" style={{ marginTop: '20px' }}>
          <H3Button
            buttonType={defaultButtonTypes.BLUE_ROUNDED}
            text="Add New Address"
            onClick={() => this.addAddress()}
            isLoading={createAddressLoading}
            disabled={createAddressLoading}
            style={{
              width: '200px',
              borderRadius: '5px',
              padding: '7px 0px',
              marginLeft: '0',
            }}
          />
        </div>
      </div>

    );
  }
}

const mapStateToProps = ({
  SellerReducers, ProductReducers, TenantReducers, AddressReducer, UserReducers, GetTallyConfigurations,
}) => ({
  cityStateLoading: SellerReducers.cityStateLoading,
  pincodeCity: SellerReducers.pincodeCity,
  pincodeState: SellerReducers.pincodeState,
  setCityStateError: SellerReducers.setCityStateError,
  createSellerLoading: SellerReducers.createSellerLoading,
  addProductToInventoryLoading: ProductReducers.addProductToInventoryLoading,
  tenants: TenantReducers.tenants,
  products: ProductReducers.products,
  createAddressLoading: AddressReducer.createAddressLoading,
  user: UserReducers.user,
  tallyConfigurations: GetTallyConfigurations.data,
  tallyConfigurationsLoading: GetTallyConfigurations.loading,
});

const mapDispatchToProps = (dispatch) => ({
  setCityState: (city, state) => dispatch(SellerActions.setCityState(city, state)),
  getCityState: (pincode) => dispatch(SellerActions.getCityState(pincode)),
  createAddress: (payload, callback) => dispatch(AddressActions.createAddress(payload, callback)),
  addProductToInventory: (payload, callback) => dispatch(ProductActions.addProductToInventory(payload, callback)),
  getProducts: (category, page, keyword, orgId, mapSkuOffer) => dispatch(
    ProductActions.getProducts(category, page, keyword, orgId, mapSkuOffer),
  ),
  getTallyConfigurations: (payload, callback) => dispatch(GetTallyConfigurations.actions.request(payload, callback)),
});

NewAddressForm.propTypes = {
  pincodeCity: PropTypes.string,
  createAddressLoading: PropTypes.any,
  pincodeState: PropTypes.string,
  setCityState: PropTypes.func,
  user: PropTypes.any,
  callback: PropTypes.any,
  seller: PropTypes.any,
  selectedTenantId: PropTypes.any,
  entityType: PropTypes.any,
  entityId: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NewAddressForm));
